export default __webpack_public_path__ + "static/media/spid-idp-lepidaid.0b7e74a1.png";